var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "add-to-cart", on: { click: _vm.addToCart } }, [
      _c("a", { domProps: { textContent: _vm._s(_vm.btnText) } })
    ]),
    _vm._v(" "),
    _vm.stock_error && this.variants == 1
      ? _c("p", { staticClass: "form-error" }, [
          _vm._v(_vm._s(_vm.error_translation))
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.stock_error && this.variants > 1
      ? _c("p", { staticClass: "form-error" }, [
          _vm._v(_vm._s(_vm.error_translation_variants))
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }